module.exports = {"341882001":"桐汭街道","341882002":"祠山街道","341882003":"升平街道","341882100":"桃州镇","341882101":"柏垫镇","341882102":"誓节镇","341882103":"邱村镇","341882104":"新杭镇","341882105":"杨滩镇","341882200":"卢村乡","341882201":"东亭乡","341882202":"四合乡","341882400":"广德经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341882.json
// module id = 1268
// module chunks = 0